var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.589v1.411h-2v-1.425c0-1.958-.943-3.015-2-4.575h6c-1.062 1.553-2 2.612-2 4.589zm3-9.589c-.552 0-1-.448-1-1s.448-1 1-1h2v-2h-2c-.552 0-1-.448-1-1s.448-1 1-1h2v-2h-2c-.552 0-1-.448-1-1s.448-1 1-1h1.858c-.446-1.722-1.997-3-3.858-3h-4c-1.861 0-3.412 1.278-3.858 3h1.858c.552 0 1 .448 1 1s-.448 1-1 1h-2v2h2c.552 0 1 .448 1 1s-.448 1-1 1h-2v2h2c.552 0 1 .448 1 1s-.448 1-1 1h-1.858c.446 1.722 1.997 3 3.858 3h4c1.861 0 3.412-1.278 3.858-3h-1.858z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.3e4ec0353cf7168d41529849e7c028f0.svg";
export { ForwardRef as ReactComponent };